import React from 'react';
import T from 'prop-types';
import { Input, Form } from 'antd';

import { MODAL_FORGOT_PASSWORD } from '../../../../constants/app';

import ErrorAlert from '../../../errorAlert';
import Modal from '../../../modal';
import FormItem from '../../../formItem';

import { config } from './config';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

const ForgotPasswordModal = ({ error, errorMessage, isLoading, requestPasswordReset, reset }) => {
  const handleOnFinish = (v) => {
    requestPasswordReset(v);
  };

  return (
    <Modal
      name={MODAL_FORGOT_PASSWORD}
      okButtonProps={{ htmlType: 'submit', form: MODAL_FORGOT_PASSWORD, loading: isLoading }}
      okText="Reset Password"
      onCancel={reset}
      title="Reset Password"
    >
      <ErrorAlert message={errorMessage} visible={error} />

      <Form name={MODAL_FORGOT_PASSWORD} onFinish={handleOnFinish} {...formItemLayout}>
        <FormItem label="E-mail" name="email" {...config.email}>
          <Input />
        </FormItem>
      </Form>
    </Modal>
  );
};

ForgotPasswordModal.propTypes = {
  requestPasswordReset: T.func.isRequired,
  reset: T.func.isRequired,

  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  isLoading: T.bool.isRequired,
};

export default ForgotPasswordModal;
